module.exports = __webpack_public_path__ + "static/media/bus11.4818addf.png";